import React from 'react';
import { Flex, Icon, NakedButton } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import Flight from '@/propTypes/Flight';
import { useGA4Events } from '@/v2/hooks/featureFlags/ga4Events/useGA4Events';
import dataLayer from '@/v2/utils/dataLayer';

const FlightsDetailsToggle = ({ expanded, setExpanded, flights }) => {
  const shouldUseNewEvents = useGA4Events();

  return (
    <NakedButton
      color="ui.link"
      hoverColor="ui.linkHover"
      onClick={() => {
        setExpanded((prevExpanded) => !prevExpanded);
        if (shouldUseNewEvents && !expanded) {
          const itemName =
            flights?.length < 2
              ? `${flights[0].flightNumber} ${flights[0].flightClass}`
              : `${flights[0].flightNumber} ${flights[0].flightClass} - ${flights[1].flightNumber} ${flights[1].flightClass}`;

          dataLayer.accordionOpenEvent({
            groupName: 'Flights Page',
            itemName,
          });
        }
      }}
    >
      <Flex alignItems="center" fontSize="sm">
        {expanded ? 'Hide flight details' : 'Show flight details'}
        <Icon name={expanded ? 'expandLess' : 'expandMore'} />
      </Flex>
    </NakedButton>
  );
};

FlightsDetailsToggle.propTypes = {
  flights: PropTypes.arrayOf(PropTypes.shape(Flight)),
  expanded: PropTypes.bool.isRequired,
  setExpanded: PropTypes.func.isRequired,
};

export default FlightsDetailsToggle;
